// components/master/MasterConsole.tsx
//
// The FATER MASTER surface: the operator view where you give a high-level goal
// and the master executes it on the app's own rails, rendering results in the
// existing chat timeline (ChatTab with the ChatGPT-style composer). No bespoke
// telemetry UI, no separate framing chrome.
'use client';

import ChatTab from '@/components/ChatTab';
import { MasterConversationMenu } from '@/components/master/MasterConversationMenu';

function MasterConsole() {
  // Full-width wrapper (no max-width column here): the chat's own scroll container
  // spans the whole area so wheeling over the empty gutters scrolls the transcript.
  // Content and composer are centered at a fixed width INSIDE that scroll area, so the
  // layout looks identical to a centered column but the whole width is scrollable.
  return (
    <div className="relative flex h-full w-full flex-col bg-black">
      {/* ChatGPT-style Share + kebab conversation controls, top-right. Self-gates to
          render only inside an actual Master conversation. */}
      <MasterConversationMenu />
      <div className="min-h-0 flex-1">
        <ChatTab chatGptComposer />
      </div>
    </div>
  );
}

export default MasterConsole;
